import { attr, html } from '@tempots/dom'

export function HR() {
  return html.hr(attr.class('border-gray-300 my-2'))
}
